// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/Opengraph/MetatagsCards/Slack.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/Opengraph/MetatagsCards/Slack.tsx");
  import.meta.hot.lastModified = "1732036225890.3115";
}
// REMIX HMR END

import Heading from "~/components/Heading";
export function Slack({
  title,
  description,
  image,
  favicon
}) {
  return <div id="slack">
      <div className="card-slack mt-[13px] flex break-words max-w-[520px] min-[770px]">
        <div className="w-1 bg-[#e8e8e8] rounded-lg"></div>
        <div className="px-[13px] py-1 text-[12px] leading-3 break-words w-full">
          <img src={favicon} alt="Favicon" className="h-4 inline mr-[9px]" />
          <div className="inline-block translate-y-[2px]">
            <Heading tag="h2" className="text-[#717274]">
              Meta Tags
            </Heading>
          </div>
          <p className="text-blue-600 font-bold text-[15px] leading-6 tracking-tighter">
            {title}
          </p>
          <span className="!text-[#2c2d30] leading-[22px] text-[15px] tracking-tight" dangerouslySetInnerHTML={{
          __html: description
        }} />

          <div className="card-slack-image max-w-[360px] h-[189px] border border-gray-300 rounded mt-1  bg-contain bg-center bg-cover" style={{
          backgroundImage: `url("${image}")`
        }}></div>
        </div>
      </div>
    </div>;
}
_c = Slack;
var _c;
$RefreshReg$(_c, "Slack");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;